import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * 是否有載入動作進行中，所有實例共用，整頁一起擋點擊
 */
const isLoading = ref(false)

/**
 * 「顯示 Loading toast、等待、收 toast」的共用流程（v3 8.6）
 * 進行中 <html> 掛 .is-loading，按鈕用 isLoading 綁 disabled
 * @param labelKey {string} Loading toast 文字的 i18n key，例如 Loading.Joining
 * @param action {() => T | Promise<T>} 要等待的動作
 * @return {{ isLoading: Ref<boolean>, run: () => Promise<T | undefined> }}
 */
export const useLoadingAction = <T>(labelKey: string, action: () => T | Promise<T>) => {
	// 取得 i18n
	const { t } = useI18n()

	// 執行動作，進行中再呼叫會被忽略，被擋掉時回傳 undefined
	const run = async (): Promise<T | undefined> => {
		// 擋住重複點擊
		if (isLoading.value) {
			return undefined
		}

		// 進入載入狀態
		isLoading.value = true
		document.documentElement.classList.add('is-loading')
		// 顯示不會自動消失的 Loading toast，並記住自己這則的 id
		const toastId = window.$toast?.({ type: 'loading', message: t(labelKey), sticky: true })

		try {
			// 等動作做完
			return await action()
		} finally {
			// 不論成功失敗都還原狀態
			isLoading.value = false
			document.documentElement.classList.remove('is-loading')
			// 只收自己那則，action 中途彈出的錯誤 toast 要留著
			window.$hideToast?.(toastId)
		}
	}

	return { isLoading, run }
}
